import type { ICreateRequestPayload, IDeleteRequestPayload, IRenameRequestPayload, IValidations } from './types';

const ROOT = 'JOB_TYPES_MUTATIONS_';

const actions = {
  CREATE_REQUEST: `${ROOT}CREATE_REQUEST`,
  CREATE_SUCCESS: `${ROOT}CREATE_SUCCESS`,
  CREATE_ERROR: `${ROOT}CREATE_ERROR`,

  RENAME_REQUEST: `${ROOT}RENAME_REQUEST`,
  RENAME_SUCCESS: `${ROOT}RENAME_SUCCESS`,
  RENAME_ERROR: `${ROOT}RENAME_ERROR`,

  DELETE_REQUEST: `${ROOT}DELETE_REQUEST`,
  DELETE_SUCCESS: `${ROOT}DELETE_SUCCESS`,
  DELETE_ERROR: `${ROOT}DELETE_ERROR`,

  CLEAR_STORE: `${ROOT}CLEAR_STORE`,

  createRequest: (payload: ICreateRequestPayload) => ({ type: actions.CREATE_REQUEST, payload }),
  createSuccess: () => ({ type: actions.CREATE_SUCCESS }),
  createError: (payload: { validations: IValidations | null }) => ({ type: actions.CREATE_ERROR, payload }),

  renameRequest: (payload: IRenameRequestPayload) => ({ type: actions.RENAME_REQUEST, payload }),
  renameSuccess: () => ({ type: actions.RENAME_SUCCESS }),
  renameError: (payload: { validations: IValidations | null }) => ({ type: actions.RENAME_ERROR, payload }),

  deleteRequest: (payload: IDeleteRequestPayload) => ({ type: actions.DELETE_REQUEST, payload }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  // No field to write a message under, so only the failure is stored; the saga raises the reason.
  deleteError: () => ({ type: actions.DELETE_ERROR }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
